module.exports = __webpack_public_path__ + "img/ring_skip_0_1_1@3x.34f9ad5b.png";